import { combineReducers } from 'redux'

import calendar from './calendar'
import modal from './modal'
import queueTimes from './queueTimes'

const rootReducer = combineReducers({
  modal,
  queueTimes,
  calendar,
})

export type RootState = ReturnType<typeof rootReducer>

export default rootReducer
